import alphanumeric from "libs/makeIDs";
import React from "react";
import { fullOrderType, timeGroupsType } from "types";
import { useSelector } from "react-redux";

interface AvailableTimesProps {
  times: timeGroupsType[];
  selectPerform: (perfID: string, selected: "on" | "") => void;
}

const useReduxState = () => {
  return useSelector((state: fullOrderType) => ({
    event: state.event,
  }));
};

const AvailableTimes = ({ times, selectPerform }: AvailableTimesProps) => {
  const { event } = useReduxState();

  return (
    <>
      {times.map((availableTimes, i) => {
        return (
          <div key={`avatimes${i}`}>
            <h3 className="available-times__title">
              Available Times for {availableTimes.name}
              {availableTimes.error === "on" && (
                <div className="available-times__title-error">Please select your session time below</div>
              )}
            </h3>
            {availableTimes.times.map((availableTime, i) => {
              let disableIt = availableTime.available === false || availableTime.spotLeft < event.totalTickets;
              return (
                <button
                  key={i}
                  onClick={() => {
                    if (!availableTime.available) {
                      return;
                    }
                    selectPerform(availableTime.perfID, availableTime.selected);
                  }}
                  type="button"
                  className={`select-btn ${availableTime.selected === "on" ? "is-active" : ""}`}
                  disabled={disableIt}
                  id={`selectTime-${alphanumeric(availableTime.perfID)}`}
                >
                  {availableTime.text}
                  {/* <span>{availableTime.spotLeft} spots left</span> */}
                </button>
              );
            })}
          </div>
        );
      })}
    </>
  );
};

AvailableTimes.defaultProps = {};

export default AvailableTimes;
